import type { ChipProps } from '@mui/material';
import type { CodelistEntryStatus, CodelistVersionStatus } from '../../api/types';

// The kinds are named once, on the Mappings page they belong to, so both pages read alike.
export { kindLabelKeys } from '../mappings/mappingKinds';

export const versionStatusLabelKeys = {
  Draft: 'codelists.versions.status.Draft',
  Active: 'codelists.versions.status.Active',
  Superseded: 'codelists.versions.status.Superseded',
} as const satisfies Record<CodelistVersionStatus, string>;

export const versionStatusColors: Record<CodelistVersionStatus, ChipProps['color']> = {
  Draft: 'warning',
  Active: 'success',
  Superseded: 'default',
};

export const entryStatusLabelKeys = {
  Active: 'codelists.versions.entryStatus.Active',
  New: 'codelists.versions.entryStatus.New',
  Deprecated: 'codelists.versions.entryStatus.Deprecated',
} as const satisfies Record<CodelistEntryStatus, string>;

export const entryStatusColors: Record<CodelistEntryStatus, ChipProps['color']> = {
  Active: 'default',
  New: 'success',
  Deprecated: 'error',
};
